import { render } from "./PanelResultData.vue?vue&type=template&id=05622d21&scoped=true"
import script from "./PanelResultData.vue?vue&type=script&lang=js"
export * from "./PanelResultData.vue?vue&type=script&lang=js"

import "./PanelResultData.vue?vue&type=style&index=0&id=05622d21&lang=less&scoped=true"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05622d21"]])

export default __exports__